import { render, staticRenderFns } from "./supplierCharge.vue?vue&type=template&id=225db94a&"
import script from "./supplierCharge.vue?vue&type=script&lang=js&"
export * from "./supplierCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('225db94a')) {
      api.createRecord('225db94a', component.options)
    } else {
      api.reload('225db94a', component.options)
    }
    module.hot.accept("./supplierCharge.vue?vue&type=template&id=225db94a&", function () {
      api.rerender('225db94a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/ChargeConfirmed/supplierCharge.vue"
export default component.exports